import { forwardRef } from 'react'
import LinkHOC from 'platform/react/hoc/link'
import Section from 'ui/Element/Section'

const SectionAsLink = LinkHOC(forwardRef(Section))

export default SectionAsLink
